module.exports = require("./da-DK.js");